// extracted by mini-css-extract-plugin
module.exports = {"event-nav":"eventsIndex_event-nav___1cli"};